/**
 * The image provider's mark on Generate (spec 027 D-11): OpenAI's monochrome
 * mark, inlined so it takes the button's colour in light and dark.
 */
import React from 'react';
import openaiSvg from '../../assets/providers/openai.svg?raw';
import styles from './ImageGen.module.scss';

export const ProviderMark: React.FC = () => (
  // The SVG is a static asset in this repo, not user content.
  <span className={styles.mark} aria-hidden="true" data-testid="provider-mark" dangerouslySetInnerHTML={{ __html: openaiSvg }} />
);

export default ProviderMark;
